import * as types from 'actions/actionTypes';
import initialState from 'reducers/initialState';

export default (state = initialState.surveyStep, action) => {
  switch (action.type) {
    case types.SURVEY_STEP_NEXT:
      return state + 1;

    case types.SURVEY_STEP_PREV:
      return state - 1;

    case types.SURVEY_STEP_FIRST:
      return 1;

    case types.LOG_OUT.SUCCESS:
      return initialState.surveyStep;

    default:
      return state;
  }
};
